/**
 * @name isElementInViewport
 *
 * @description Detects if an element is visible in the viewport. Also returns true if parts of the element are visible
 *
 * @example
 * import { isElementInViewport } from '@workbench/core';
 *
 * isElementInViewport(submitButtonEl); // true
 */
export const isElementInViewport = (el: HTMLElement): boolean => {
  const bounds = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const vertInView = bounds.top <= windowHeight && bounds.top + bounds.height >= 0;
  const horInView = bounds.left <= windowWidth && bounds.left + bounds.width >= 0;
  return vertInView && horInView;
};
